// extracted by mini-css-extract-plugin
export default {"FloatButton":"FloatButton_FloatButton__9IQmA","IsLeft":"FloatButton_IsLeft__j+NW3"};